<template>
  <div class="view pa24">

    <el-dialog
        :title="title"
        width="800px"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="dealerRuleForm"
          label-width="100px"
          class="ruleForm"
      >
        <el-form-item label="所属父级">
          <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull"
                     v-model="parentName" style="width: 300px;" name='option 1'>
            <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.label"
                       style="display: none;" />
            <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
                     highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode"/>
          </el-select>
        </el-form-item>
        <el-form-item label="类别名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" >
          <el-input type="number" v-model="ruleForm.sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss" @click="confirmAddCustomer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {selectAllCategory,addOrUpdateCategory} from '@/api/productCategory.js'
export default {
  name: "addPageClass",
  components: {
    // BaiduMap,
  },
  props: [],

  data() {
    return {
      dialogVisible: false,
      title: '添加类别',
      classList:[{id:'',label:'顶级',children:null}],
      ruleForm: {
        id:'',
        name: '',
        sort:999,
        parentId:'',
      },
      parentName:'',
      rules: {
        name: [
          {required: true, message: '请输入类别名称', trigger: 'blur'},
        ],
      },
      treeProps: {
        children: 'children',
        label: 'name'
      },
      expandOnClickNode: false,
    };
  },
  onShow() {
  },
  methods: {
    loadMenus({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        if (parentNode.children){
          parentNode.children = parentNode.children.map(function(obj) {
            obj.leaf = false
            return obj
          })
        }else {
          parentNode.children = []
        }
        setTimeout(() => {
          callback()
        }, 100)
      }
    },
    getAllClass(){
      selectAllCategory().then(res => {
        this.classList = [{id: '', name: '顶级', children: res.data}]
      })
    },
    openDialog(type, data) {
      this.resetForm()
      this.getAllClass()
      this.dialogVisible = true
      if (type === 'add') {
        this.title = '添加类别'
        this.id = ''
        this.ruleForm.name = ''
        this.ruleForm.sort = 999
        this.parentName = "顶级"
      } else {
        this.title = '编辑类别'
        this.getData(data)
        this.type = "edit"
        this.id = data.id
      }
    },
    resetForm(){
      this.ruleForm.id = ''
      this.ruleForm.name = ''
      this.ruleForm.sort = 999
      this.ruleForm.parentId = ''
      this.parentName = ''
    },
    handleNodeClick(node) {
      this.ruleForm.parentId = node.id
      this.parentName = node.fullName?node.fullName:node.name;
      this.$refs.selectTree.blur();
    },
    setValueNull() {
      this.ruleForm.parentId ='';
      this.parentName = ''
    },
    optionData(array, result = []) {
				array.forEach(item => {
					result.push({
						label: item.name,
						value: item.id
					})
					if (item.children && item.children.length !== 0) {
						this.optionData(item.children, result)
					}
				})
				return JSON.parse(JSON.stringify(result))
			},
    closeDialog() {
      this.$emit('saveRefresh',this.ruleForm.parentId?this.ruleForm.parentId:this.ruleForm.id)
      this.dialogVisible = false
      this.resetForm()
    },
    confirmAddCustomer() {
      this.$refs.dealerRuleForm.validate((valid) => {
        if (valid) {
          let params = {
            id:this.ruleForm.id,
            name: this.ruleForm.name,
            sort: this.ruleForm.sort,
            parentId: this.ruleForm.parentId,
          }
          addOrUpdateCategory(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.closeDialog()
            }
          })

        }
      })
    },
    // 回显
    getData(data) {
      this.ruleForm.name = data.name
      this.ruleForm.sort = data.sort
      this.ruleForm.parentId = data.parentId
      this.ruleForm.id = data.id
      this.parentName = data.parentName?data.parentName:'顶级'
    },
  },


};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}
::v-deep .vue-treeselect__control,::v-deep .vue-treeselect__placeholder,::v-deep .vue-treeselect__single-value {
  height: 30px;
  line-height: 30px;
}
</style>
